export const ACCESS_TOKEN = 'Access-Token'
export const TOGGLE_MOBILE_TYPE = 'is_mobile'
export const APP_LANGUAGE = 'app_language'
export const USER_INFO = 'user_info'

export const NAV_THEME = {
  LIGHT: 'light',
  DARK: 'dark'
}
